import { CartQuery } from '@graphql/generated';

type Props = {
  data: CartQuery['cart'];
};

export const Banner = ({ data }: Props) => {
  if (!data || !data.bannerImage) {
    return null;
  }

  return (
    <div className="cart__banner" style={{ backgroundImage: `url(${data.bannerImage?.url})` }}>
      <div className="cart__banner__text">{data.bannerText}</div>
    </div>
  );
};

export default Banner;
